// LocalStorage helpers for managing player tokens

const TOKEN_KEY = 'competitionTokens';

// Get all stored tokens
export const getStoredTokens = () => {
  try {
    const tokens = localStorage.getItem(TOKEN_KEY);
    return tokens ? JSON.parse(tokens) : {};
  } catch (error) {
    console.error('Error reading tokens from localStorage:', error);
    return {};
  }
};

// Get token for a specific competition
export const getTokenForCompetition = (competitionId) => {
  const tokens = getStoredTokens();
  return tokens[competitionId] || null;
};

// Store a token for a competition
export const storeToken = (competitionId, token) => {
  try {
    const tokens = getStoredTokens();
    tokens[competitionId] = token;
    localStorage.setItem(TOKEN_KEY, JSON.stringify(tokens));
  } catch (error) {
    console.error('Error storing token:', error);
  }
};

// Remove token for a competition
export const removeToken = (competitionId) => {
  try {
    const tokens = getStoredTokens();
    delete tokens[competitionId];
    localStorage.setItem(TOKEN_KEY, JSON.stringify(tokens));
  } catch (error) {
    console.error('Error removing token:', error);
  }
};

// Get all competition IDs that have tokens
export const getCompetitionIdsWithTokens = () => {
  const tokens = getStoredTokens();
  return Object.keys(tokens);
};

// Store last visited competition
export const setLastVisitedCompetition = (competitionId) => {
  try {
    localStorage.setItem('lastVisitedCompetition', competitionId);
  } catch (error) {
    console.error('Error storing last visited competition:', error);
  }
};

// Get last visited competition
export const getLastVisitedCompetition = () => {
  try {
    return localStorage.getItem('lastVisitedCompetition');
  } catch (error) {
    console.error('Error reading last visited competition:', error);
    return null;
  }
};
